var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24525_133456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.08333C21.0479 2.08333 22.9167 3.95208 22.9167 6.25V18.75C22.9167 21.0479 21.0479 22.9167 18.75 22.9167H6.25C3.95208 22.9167 2.08333 21.0479 2.08333 18.75V6.25C2.08333 3.95208 3.95208 2.08333 6.25 2.08333H18.75ZM18.75 0H6.25C2.79792 0 0 2.79792 0 6.25V18.75C0 22.2021 2.79792 25 6.25 25H18.75C22.2021 25 25 22.2021 25 18.75V6.25C25 2.79792 22.2021 0 18.75 0Z",
    fill: "#2999BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5026 18.75C11.9276 18.75 11.4609 18.2844 11.4609 17.7083V7.29167C11.4609 6.71667 11.9276 6.25 12.5026 6.25C13.0776 6.25 13.5443 6.71667 13.5443 7.29167V17.7083C13.5443 18.2844 13.0776 18.75 12.5026 18.75Z",
    fill: "#2999BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.4987C6.25 11.9237 6.71563 11.457 7.29167 11.457H17.7083C18.2833 11.457 18.75 11.9237 18.75 12.4987C18.75 13.0737 18.2833 13.5404 17.7083 13.5404H7.29167C6.71563 13.5404 6.25 13.0737 6.25 12.4987Z",
    fill: "#2999BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24525_133456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddicon);
export default __webpack_public_path__ + "static/media/addicon.2284a514071a06d11ecf843dfb4d7310.svg";
export { ForwardRef as ReactComponent };